import { Link } from 'react-router-dom';
import { heroImage } from '@/mocks/images';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[580px] overflow-hidden">
      <img
        src={heroImage}
        alt="健康性知识科普平台 - 安全健康的成人知识科普"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-full max-w-3xl mx-auto px-4 md:px-6 text-center">
          <h1 className="text-3xl md:text-5xl font-heading font-bold text-white mb-4 leading-tight">
            安全健康的成人知识科普平台
          </h1>
          <p className="text-base md:text-lg text-white/85 mb-8 max-w-xl mx-auto leading-relaxed">
            提供科学的性教育资讯、网络安全防护指南与隐私保护建议，帮助您理性看待成人内容，守护身心健康
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/sex-education"
              className="w-full sm:w-auto px-8 py-3 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-md transition-colors whitespace-nowrap"
            >
              开始学习
            </Link>
            <Link
              to="/about"
              className="w-full sm:w-auto px-8 py-3 bg-white/15 hover:bg-white/25 text-white font-medium rounded-md backdrop-blur-sm transition-colors whitespace-nowrap"
            >
              了解更多
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}